var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCentos11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2248_58695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4829 14.8308L14.6365 15.9779L13.4829 17.1248H5.36301V20.9461L0.411133 15.9779L5.36301 11.0929V14.8308H13.4829ZM17.0521 5.07227H26.9183V14.9385H17.0521V5.07227Z",
    fill: "#932279"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1593 13.4819L16.0124 14.6355L14.8656 13.4819V5.36203H11.0439L16.0124 0.410156L20.8971 5.36203H17.1593V13.4819ZM17.0518 17.0512H26.9178V26.9174H17.0517L17.0518 17.0512Z",
    fill: "#EFA724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5078 17.1583L17.354 16.0115L18.5078 14.8646H26.6275V11.043L31.5796 16.0115L26.6275 20.8961V17.1583H18.5078ZM5.07227 17.0508H14.9384V26.9171H5.07227V17.0508Z",
    fill: "#262577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8308 18.5078L15.9776 17.354L17.1248 18.5078V26.6278H20.9461L15.9776 31.5796L11.0931 26.6278H14.8308V18.5078ZM5.07227 5.07227H14.9384V14.9385H5.07227V5.07227Z",
    fill: "#9CCD2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.71875 4.71875H15.2896V15.2896H4.71875V4.71875ZM5.42337 14.585H14.5847V5.42362H5.42337V14.585ZM16.6991 4.71875H27.27V15.2896H16.6991V4.71875ZM17.4037 14.585H26.5651V5.42362H17.4037V14.585ZM16.6991 16.6991H27.27V27.2703H16.6991V16.699V16.6991ZM17.4037 26.5651H26.5651V17.4037H17.4037V26.5651ZM4.71875 16.6991H15.2896V27.2703H4.71875V16.699V16.6991ZM5.42337 26.5651H14.5847V17.4037H5.42337V26.5651Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.52383 23.4701L0.0488281 15.9951L7.5237 8.52033L14.9987 15.9951L7.52383 23.4701ZM1.04558 15.9951L7.52383 22.4733L14.0018 15.9951L7.52358 9.51708L1.04558 15.9951ZM15.9951 14.9986L8.52033 7.52383L15.9951 0.0488281L23.4698 7.52383L15.9951 14.9986ZM9.51708 7.52383L15.9951 14.0018L22.4733 7.52383L15.9951 1.04558L9.51708 7.52383ZM24.4666 23.4701L16.9918 15.9951L24.4666 8.52033L31.9413 15.9951L24.4666 23.4701ZM17.9883 15.9951L24.4666 22.4733L30.9446 15.9951L24.4666 9.51708L17.9883 15.9951ZM15.9951 31.9413L8.52033 24.4666L15.9951 16.9918L23.4698 24.4666L15.9951 31.9413ZM9.51708 24.4666L15.9951 30.9446L22.4733 24.4666L15.9951 17.9886L9.51708 24.4666Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2248_58695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentos11);
export default __webpack_public_path__ + "static/media/centos-1 1.8f49565e75044249fe11e65ae1df05d8.svg";
export { ForwardRef as ReactComponent };